module.exports = __webpack_public_path__ + "media/images/front/banner_etak_side-385544820bad77834ef1896e259033f9.png";